module.exports = __webpack_public_path__ + "img/logo_mt.9d8a1af4.png";